import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "#262626",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 3.49866H16.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 9.49866H16.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.5 15.4987H16.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5332 13.24C1.66731 12.7392 2.16189 12.4239 2.67248 12.5138C3.18307 12.6036 3.54033 13.0688 3.49541 13.5853C3.45049 14.1018 3.01831 14.4983 2.49987 14.4987C3.01739 14.4984 3.44959 14.8931 3.49625 15.4085C3.54291 15.9239 3.18861 16.3898 2.67946 16.4825C2.17031 16.5752 1.67454 16.2641 1.53654 15.7653",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 8.49866C1.5 7.94637 1.94772 7.49866 2.5 7.49866V7.49866C3.05228 7.49866 3.5 7.94637 3.5 8.49866V8.49866C3.5001 8.82235 3.39007 9.13645 3.188 9.38932L1.5 10.4987H3.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 1.49866H2C2.27614 1.49866 2.5 1.72251 2.5 1.99866V5.49866",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 5.49866H3.5",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20stroke%3D%22%23262626%22%3E%3Cpath%20d%3D%22M6.5%203.49866H16.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.5%209.49866H16.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.5%2015.4987H16.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.5332%2013.24C1.66731%2012.7392%202.16189%2012.4239%202.67248%2012.5138C3.18307%2012.6036%203.54033%2013.0688%203.49541%2013.5853C3.45049%2014.1018%203.01831%2014.4983%202.49987%2014.4987C3.01739%2014.4984%203.44959%2014.8931%203.49625%2015.4085C3.54291%2015.9239%203.18861%2016.3898%202.67946%2016.4825C2.17031%2016.5752%201.67454%2016.2641%201.53654%2015.7653%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.5%208.49866C1.5%207.94637%201.94772%207.49866%202.5%207.49866V7.49866C3.05228%207.49866%203.5%207.94637%203.5%208.49866V8.49866C3.5001%208.82235%203.39007%209.13645%203.188%209.38932L1.5%2010.4987H3.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.5%201.49866H2C2.27614%201.49866%202.5%201.72251%202.5%201.99866V5.49866%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.5%205.49866H3.5%22%20stroke-width%3D%221.5%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E";
